import React, { useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo from "@/assets/nav_logo.png";
import "./index.less";
import { getCurrentLanguage, setLanguage } from "@/store/data/global";

const NewNav = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const isHomePage = location.pathname === "/";

  // 关键：用 ref 获取真实 DOM 元素
  const navRef = React.useRef(null);

  useEffect(() => {

    const handleScroll = () => {
      if (!navRef.current) return;

      if (window.scrollY > 50) {
        navRef.current.classList.add("scrolled");
      } else {
        navRef.current.classList.remove("scrolled");
      }
    };

    // 立即执行一次（防止刷新后在顶部但类没移除）
    handleScroll();

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  const navItems = useMemo(() => [
    { path: "/", key: "/", name: { EN: "Home", ES: "Página de Inicio" } },
    { path: "/products", key: "products", name: { EN: "Products", ES: "Productos" } },
    { path: "/clients", key: "clients", name: { EN: "Clients & Business Scenarios", ES: "Clientes y Escenarios de Negocio" } },
    { path: "/about", key: "about", name: { EN: "About Us", ES: "Nosotros" } },
    { path: "/services", key: "services", name: { EN: "Services & Cooperation", ES: "Servicio y Colaboración" } },
  ], []);

  const isActiveLink = (item) => location.pathname === item.path || (location.pathname === "/" && item.key === "/");

  return (
    <div className="new_nav_page" ref={navRef}>
      <div className="nav_warp">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" className="logo-image" />
          </Link>
        </div>

        <div className="nav_list">
          {navItems.map((item) => (
            <div className="nav_item" key={item.key}>
              <Link to={item.path} className={isActiveLink(item) ? "active" : ""}>
                {item.name[currentLanguage]}
              </Link>
            </div>
          ))}
        </div>

        <div className="lang flex">
          {["ES", "EN"].map((code) => (
            <div className="lang_item" key={code}>
              <span
                className={currentLanguage === code ? "active" : ""}
                onClick={() => dispatch(setLanguage(code))}
              >
                {code}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewNav;